module.exports = __webpack_public_path__ + "static/media/profile.0d66e206.svg";